module.exports = __webpack_public_path__ + "static/dummy_image-46d906ad21d1eaa27247ffa157a5c83e.png";